import styled from 'styled-components';
import { motion } from 'framer-motion';
import { disableUserSelect, media } from '@quizzach/styles';

export const PremadeQuizzesByIdContainer = styled(motion.div)<{
	$backgroundImage?: string;
}>`
	.premade-quizzes-placeholder {
		border-radius: var(--r-card);
		background: ${({ theme }) =>
			`linear-gradient(-90deg, ${theme.palette.surface.main} 0%, ${theme.palette.surface.soft}  50%, ${theme.palette.surface.main}  100%)`};
		background-size: 400% 400%;
		animation: loadingPulse 1.2s ease-in-out infinite;
		line-height: 1;
	}
	.premade-quizzes-content-wrapper {
		width: 100%;
		text-align: left;
		position: relative;
		z-index: 100;
		padding: 150px 10px 15px 10px;
	}
	.premade-quizzes-card-tags {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: wrap;
		gap: 10px;
	}
	.premade-quizzes-info {
		background-color: ${({ theme }) => theme.palette.premade.transparent};
		color: ${({ theme }) => theme.palette.text.white};
		border-radius: var(--r-card);
		width: fit-content;
		margin: 30px 0px;
		width: 100%;
		padding: 20px;

		.flex {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin: 5px 0px;
			height: 30px;
			& > :last-child {
				margin-left: 5px;
			}
		}
	}
	.premade-quizzes-score {
		font-weight: 600;
		font-family: ${({ theme }) => theme.typography.fontPrimary};
		color: ${({ theme }) => theme.palette.brand.main};
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
	}
	.premade-quizzes-level {
		${disableUserSelect}
		font-family: ${({ theme }) => theme.typography.fontPrimary};
		color: ${({ theme }) => theme.palette.white};
		font-size: 20px;
		margin: 0px 5px;
		font-weight: 600;
		font-size: 16px;
	}
	.active {
		color: ${({ theme }) => theme.palette.brand.main};
	}
	.premade-quizzes-by-id-cover {
		position: relative;
		overflow: hidden;
	}

	.premade-quizzes-tag {
		gap: 5px;
		background-color: ${({ theme }) => theme.palette.premade.transparent};
		padding: 7px 12px;
		border-radius: var(--r-card);
		color: ${({ theme }) => theme.palette.brand.main};
	}
	.premade-quiz-info-logo {
		margin-bottom: -3px;
	}

	.premade-quizzach-logo {
		margin: 0px 15px;
	}
	.premade-quizzes-by-id-cover::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 400px;
		background-image: ${({ $backgroundImage, theme }) =>
			$backgroundImage
				? `linear-gradient(to bottom, rgb(0 0 0 / 84%),	 ${theme.palette.surface.transparent}, ${theme.palette.surface.minimal}), url("${$backgroundImage}")`
				: 'none'};
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		z-index: 1;
	}
	.flex-inline {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		& > :first-child {
			margin: 10px 10px 10px 0px;
		}
	}

	.logo-nogac {
		width: 40px;
	}

	.logo-vragolasti {
		width: 90px;
	}

	.logo-vragolasti-big {
		width: 150px;
	}

	.logo-nogac-big {
		width: 60px;
		margin-left: 5px;
	}

	${media.tablet} {
		.premade-quizzes-by-id-cover::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 400px;
			background-image: ${({ $backgroundImage, theme }) =>
				$backgroundImage
					? `linear-gradient(to bottom, rgb(0 0 0 / 84%),	 ${theme.palette.surface.transparent}, ${theme.palette.surface.minimal}), url("${$backgroundImage}")`
					: 'none'};
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
			z-index: 1;
		}

		.logo-nogac {
			width: 60px;
		}

		.logo-nogac-big {
			width: 90px;
			margin-left: 10px;
		}
		.logo-vragolasti {
			width: 100px;
		}

		.logo-vragolasti-big {
			width: 190px;
		}
	}

	${media.smallDesktop} {
		.premade-quizzes-content-wrapper {
			max-width: 1900px;
			padding: 20px 40px;
			margin: 0px auto;

			display: flex;
			flex-direction: column;
			flex-grow: 1;
		}

		.premade-quizzach-logo {
			margin: 0px 30px;
		}
		.flex-inline,
		.flex-title-tags {
			display: flex;
			align-items: center;
			gap: 20px;

			a {
				margin: 0px;
			}
		}

		.premade-quizzes-tag {
			gap: 10px;
			padding: 10px 20px;
			color: ${({ theme }) => theme.palette.white};
			&:hover {
				transition: 0.5s;
				color: ${({ theme }) => theme.palette.brand.main};
			}
		}

		.premade-quizzes-by-id-cover {
			width: 100%;
			min-height: fit-content;
			background-image: ${({ $backgroundImage }) =>
				$backgroundImage ? `url("${$backgroundImage}")` : 'none'};

			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;

			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-content: flex-start;
		}

		.premade-quizzes-by-id-cover::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: ${({ theme }) => `linear-gradient(
				to bottom,
				rgb(0 0 0 / 84%),
					 ${theme.palette.surface.transparent},
				 ${theme.palette.surface.minimal})`};
			z-index: 1;
			pointer-events: none;
		}

		.premade-quizzes-by-id-cover > * {
			position: relative;
			z-index: 2;
		}

		.premade-quizzes-score {
			border-radius: 50%;
			background-color: ${({ theme }) => theme.palette.quiz.pointsBackground};
			font-family: ${({ theme }) => theme.typography.fontPrimary};
			color: ${({ theme }) => theme.palette.quiz.pointsText};
			border: none;
			width: 40px;
			height: 40px;
			font-size: 22px;
		}

		.premade-quizzes-level {
			font-size: 20px;
		}

		.premade-quizzes-info {
			padding: 30px;
			.flex {
				height: 40px;
			}
		}

		.logo-nogac {
			width: 60px;
			margin-left: 5px;
		}

		.logo-nogac-big {
			width: 120px;
			margin-left: 10px;
		}

		.logo-vragolasti {
			width: 130px;
		}

		.logo-vragolasti-big {
			width: 300px;
		}
	}

	${media.extraLargeDesktop} {
		.logo-nogac-big {
			width: 150px;
			margin-left: 13px;
		}
	}
`;

export const Label = styled.div`
	gap: 5px;
	display: flex;
	align-items: center;
	border-radius: var(--r-card);
	margin: 10px 0px 30px;
	cursor: pointer;
`;
